import produce from 'immer';
import {
  ReadSearchApiArg,
  SearchFilterConditionDate,
  SearchScope,
} from 'lib-search-types';
import moment from 'moment-timezone';
import { Writable } from 'ts-essentials';

import { isDateFilterField } from 'app/views/layout/views/search/utils/date/isDateFilterField';
import { isLeafFilterCondition } from 'app/views/layout/views/search/utils/filters/filterTypeGuards';

export function transformReadSearchArg<
  TScope extends SearchScope,
  TEnriched extends boolean = false,
>(arg: ReadSearchApiArg<TScope, TEnriched>): typeof arg {
  return produce(arg, (draftArg) => {
    if (draftArg.filters) {
      draftArg.filters.filters.forEach((condition) => {
        if (
          isLeafFilterCondition(condition) &&
          isDateFilterField(condition.field)
        ) {
          (condition as Writable<SearchFilterConditionDate>).meta = {
            timezone: moment.tz.guess(),
          };
        }
      });
    }
  });
}
